import { BrowserRouter } from "react-router";
import { AppRoutes } from "@/routes";

export function App() {
    return (
        <BrowserRouter>
            <AppRoutes />
        </BrowserRouter>
    );
}

export default App;
